import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const CoverCont = styled.div({
  '.select':{
    borderColor:`${v.ezMainColor}`
  },
})

export const HeaderTitle = styled.div({
  display: "flex",
  justifyContent: "space-between",
  alignItems: 'end',
  padding: '0.3125rem 0.625rem',
  border: '1px solid rgba(34,36,38,.15)',
  borderRadius: '0.5rem',
  width: '50%',
  marginTop: '1rem',
  cursor: 'pointer',
  fontWeight:'bold',

  ':hover':{
    borderColor:`${v.ezMainColor}`
  }
});

export const GRCont = styled.div({
  display: "flex",

  '.line1':{
    borderRight: '1px solid rgba(34,36,38,1)',
    height: '1rem',
    marginTop: '0.5rem',
    marginLeft: '1rem',
  },
  '.line2':{
    borderBottom: '1px solid rgba(34,36,38,1)',
    height: '1rem',
    marginTop: '0.5rem',
    width: '1rem',
  },
});

export const GRTitle = styled.div({
  display: "flex",
  alignItems: 'end',
  marginTop: '0.5rem',
  padding: '0.3125rem 0.625rem',
  width: '50%',

  '.txt':{
    cursor: 'pointer',
    fontWeight:'bold'
  }
});

export const GRItemCont = styled.div({
  display: "flex",
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: '0.6rem',
  width: '100%',
  border: '1px solid rgba(34,36,38,.15)',
  borderRadius: '0.5rem',

  '@media only screen and (min-width: 600px)': {
    width: '100%',
  },

  '@media only screen and (min-width: 769px)': {
    width: '50%',
  },
});

export const GRItemHeader = styled.div({
  display: "flex",
  alignItems: 'center',
  width: '100%',
  background: '#F5F6FA',
  fontWeight:'bold',
  minHeight:'1.6rem',
  borderTopLeftRadius: '0.5rem',
  borderTopRightRadius: '0.5rem',

  'div': {
    lineHeight:'2rem',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    borderRight: '1px solid rgba(34,36,38,.15)',
  },

  'div:last-child':{
    borderRight:'none'
  }

});

export const GRItemRow = styled.div({
  display: "flex",
  alignItems: 'center',
  width: '100%',

  'div': {
    lineHeight:'2rem',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    borderRight: '1px solid rgba(34,36,38,.15)',
    borderTop: '1px solid rgba(34,36,38,.15)',
  },

  'div:last-child':{
    borderRight:'none'
  }
});